<template>
  <div class="user-layer middle" v-if="hiddenLayer">
    <div class="user-layer-del middle hidden-xs hidden-sm" @click="hiddenLayerBtn">
      <img src="@/images/userDel.png" alt="#" class="layer-del-img"/>
    </div>

    <div class="phone-user-layer-del middle hidden-md hidden-lg" @click="hiddenLayerBtn">
      <img src="@/images/userDel.png" alt="#" class="phone-layer-del-img"/>
    </div>

    <div class="row">
      <div class="user-layer-center hidden-xs hidden-sm" v-if="type=='login'">
        <div class="layer-center-title middle">
          <img src="@/images/loginLayer.png" alt="#" class="center-title-img"/>
          <div class="center-title-font">{{lanType==1?'登 录':'Sign in'}}</div>
        </div>
        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon1.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'邮箱':'email'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="pcEmail" :placeholder="lanType==1?'请输入您的邮箱':'Please input your e-mail'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'密码':'password'}}</div>
          </div>
          <div class="center-list-right">
            <input type="password" v-model="pcPassword" :placeholder="lanType==1?'请输入您的密码':'Please input your password'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-btn" @click="userLogin">{{lanType==1?'立即登录':'Sign in'}}</div>
      </div>

      <div class="phone-user-layer-center hidden-md hidden-lg" v-if="type=='login'">
        <div class="phone-layer-center-title middle">
          <img src="@/images/loginLayer.png" alt="#" class="phone-center-title-img"/>
          <div class="phone-center-title-font">{{lanType==1?'登 录':'Sign in'}}</div>
        </div>
        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon1.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'邮箱':'email'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="phoneEmail" :placeholder="lanType==1?'请输入您的邮箱':'Please input your e-mail'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'密码':'password'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="password" v-model="phonePassword" :placeholder="lanType==1?'请输入您的密码':'Please input your password'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-btn" @click="userLogin">{{lanType==1?'立即登录':'Sign in'}}</div>
      </div>

      <div class="user-layer-center hidden-xs hidden-sm" v-if="type=='user'">
        <div class="layer-center-title middle">
          <img src="@/images/loginLayer2.png" alt="#" class="center-title-img"/>
          <div class="center-title-font">{{lanType==1?'注 册':'Registration'}}</div>
        </div>
        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon3.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'姓名':'name'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="name" :placeholder="lanType==1?'请输入您的姓名':'Please input your name'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon4.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'工作单位':'company'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="work" :placeholder="lanType==1?'请输入您的工作单位':'Please input your company'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon5.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'部门':'department'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="department" :placeholder="lanType==1?'请输入您的部门':'Please input your department'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon6.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'职位':'post'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="position" :placeholder="lanType==1?'请输入您的职位':'Please input your post'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon1.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'邮箱':'email'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="email" :placeholder="lanType==1?'请输入您的邮箱':'Please input your e-mail'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon7.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'电话':'phone'}}</div>
          </div>
          <div class="center-list-right">
            <input type="text" v-model="phone" :placeholder="lanType==1?'请输入您的电话':'Please input your phone'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'密码':'password'}}</div>
          </div>
          <div class="center-list-right">
            <input type="password" v-model="password" :placeholder="lanType==1?'请输入您的密码':'Please input your password'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-list spaceBetween">
          <div class="center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="list-left-img" />
            <div class="list-left-font">{{lanType==1?'确认密码':'Confirm password'}}</div>
          </div>
          <div class="center-list-right">
            <input type="password" v-model="passwordTwo" :placeholder="lanType==1?'请再次输入您的密码':'Please enter your password again'" class="list-right-input"/>
          </div>
        </div>

        <div class="layer-center-btn" @click="submitBtnSign">{{lanType==1?'立即注册':'Register'}}</div>
      </div>

      <div class="phone-user-layer-center hidden-md hidden-lg" v-if="type=='user'">
        <div class="phone-layer-center-title middle">
          <img src="@/images/loginLayer2.png" alt="#" class="phone-center-title-img"/>
          <div class="phone-center-title-font">{{lanType==1?'注 册':'Registration'}}</div>
        </div>
        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon3.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'姓名':'name'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="name" :placeholder="lanType==1?'请输入您的姓名':'Please input your name'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon4.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'工作单位':'company'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="work" :placeholder="lanType==1?'请输入您的工作单位':'Please input your company'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon5.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'部门':'department'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="department" :placeholder="lanType==1?'请输入您的部门':'Please input your department'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon6.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'职位':'post'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="position" :placeholder="lanType==1?'请输入您的职位':'Please input your post'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon1.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'邮箱':'email'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="email" :placeholder="lanType==1?'请输入您的邮箱':'Please input your e-mail'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon7.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'电话':'phone'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="text" v-model="phone" :placeholder="lanType==1?'请输入您的电话':'Please input your phone'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'密码':'password'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="password" v-model="password" :placeholder="lanType==1?'请输入您的密码':'Please input your password'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-list spaceBetween">
          <div class="phone-center-list-left start">
            <img src="@/images/loginIcon2.png" alt="#" class="phone-list-left-img" />
            <div class="phone-list-left-font">{{lanType==1?'确认密码':'Confirm password'}}</div>
          </div>
          <div class="phone-center-list-right">
            <input type="password" v-model="passwordTwo" :placeholder="lanType==1?'请再次输入您的密码':'Please enter your password again'" class="phone-list-right-input"/>
          </div>
        </div>

        <div class="phone-layer-center-btn" @click="submitBtnSign">{{lanType==1?'立即注册':'Register'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {isEmail,isMobile}  from '@/utils/util';
import config from '@/utils/config';
export default {
  name: 'user',
  data () {
    return {
      type:'user',
      hiddenLayer:false,
      pcEmail:'',
      pcPassword:'',
      isLogin:false,
      phoneEmail:'',
      phonePassword:'',
      name:'',
      work:'',
      department:'',
      position:'',
      email:'',
      phone:'',
      password:'',
      passwordTwo:'',
      lanType:1 // 1中文 2英文
    }
  },
  methods:{
    showLayerBtn(type){
      const vm=this
      vm.type=type;
      vm.hiddenLayer=true;
    },
    choiceLanType(type){
      const vm=this
      vm.lanType=type;
    },
    hiddenLayerBtn(){
      const vm=this
      vm.hiddenLayer=false;
    },
    userLogin(){
      const vm=this
      let obj={
        email:vm.pcEmail||vm.phoneEmail,
        password:vm.pcPassword||vm.phonePassword
      }
      if(!obj.email||!isEmail(obj.email)){
        vm.$toast({
          text: '请输入正确的邮箱地址',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!obj.password){
        vm.$toast({
          text: '请输入您的密码',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      axios.post(`${config.urlList.queryUrl}/api/cbh/login`,obj,).then(res => {
        if(res.data.code==1){
          vm.$toast({
            text: '登录成功！',
            type: 'success',
            duration: 1600
          })
          vm.isLogin=true;
          vm.hiddenLayer=false;
          this.$parent.login(res.data.data.token)
          localStorage.setItem('Cbhtoken', res.data.data.token);
          this.$router.go(0);
          console.log('111')
        }else{
          alert(`${res.data.message}`);
        }
      })
    },
    submitBtnSign(){
      const vm=this
      if(vm.password.length<6){
        vm.$toast({
          text: '密码长度必须大于六位！',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(vm.password!=vm.passwordTwo){
        vm.$toast({
          text: '两次密码不一致！',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      let obj={
        email:vm.email,
        password:vm.password,
        name:vm.name,
        unit_name:vm.work,
        department:vm.department,
        position:vm.position,
        tel:vm.phone
      }
      if(!isEmail(obj.email)){
        vm.$toast({
          text: '请输入正确的邮箱地址',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!obj.name){
        vm.$toast({
          text: '请输入您的姓名',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!obj.unit_name){
        vm.$toast({
          text: '请输入您的单位名称',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!obj.department){
        vm.$toast({
          text: '请输入您所在的部门名称',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!obj.position){
        vm.$toast({
          text: '请输入您的职位',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      if(!isMobile(obj.tel)){
        vm.$toast({
          text: '请输入正确的电话号码',
          type: 'wraning',
          duration: 1600
        })
        return
      }
      axios.post(`${config.urlList.queryUrl}/api/cbh/register`,obj,).then(res => {
        if(res.data.code==1){
          vm.$toast({
            text: '注册成功！',
            type: 'success',
            duration: 1600
          })
          vm.isLogin=true;
          vm.hiddenLayer=false;
          vm.pcEmail=obj.email;
          vm.phoneEmail=obj.email;
          vm.pcPassword=obj.password;
          vm.phonePassword=obj.password;
          vm.userLogin()
        }else{
          alert(`${res.data.message}`);
        }
      })
    }
  },
  computed: {
    
  }
}
</script>

<style scoped>
  .user-layer{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    z-index: 9999;
  }
  /**  pc  **/
  .user-layer-del{
    position: absolute;
    top: 0.3rem;
    right: 0.5rem;
    width: 0.2rem;
    height: 0.2rem;
    cursor: pointer;
  }
  .layer-del-img{
    width: 0.18rem;
    height: 0.18rem;
  }

  /**  web  **/
  .phone-user-layer-del{
    position: absolute;
    top: 0.3rem;
    right: 0.5rem;
    width: 0.75rem;
    height: 0.75rem;
  }
  .layer-del-img{
    width: 0.25rem;
    height: 0.25rem;
  }

  /**  pc  **/
  .user-layer-center{
    padding: 0.16rem 0.28rem;
    background: #fff;
    border-radius: 6px;
  }
  .layer-center-title{
    width: 2.8rem;
    height: auto;
    margin-bottom: 0.3rem;
  }
  .center-title-img{
    width: 0.16rem;
    height: auto;
  }
  .center-title-font{
    font-size: 0.22rem;
    color: #000;
    font-family: 'wwf';
    margin-left: 0.18rem;
  }
  .layer-center-list{
    width: 100%;
    height: 0.255rem;
    margin-bottom: 0.12rem;
  }
  .center-list-left{
    width: auto;
    height: 100%;
  }
  .list-left-img{
    width: 0.2375rem;
    height: 0.2375rem;
    margin-right: 0.02rem;
  }
  .list-left-font{
    font-size: 0.15rem;
    color: #000;
    font-family: 'wwf';
    width: 0.8rem;
    margin-right: 0.08rem;
    text-align: justify;
    height: 0.25rem;
    line-height: 0.25rem;
  }
  .list-left-font::after{
    content: "";
    display: inline-block;
    width: 100%;
  }
  .center-list-right{
    flex: 2;
    height: 100%;
    border:1px solid #999999;
  }
  .list-right-input{
    padding: 0 0.125rem;
    color: #000;
    font-size: 0.12rem;
    line-height: 0.25rem;
    width: 100%;
    border:none;
    outline:none;
    background:none;
  }
  .list-right-input:focus{   
    border:none;
  }
  .layer-center-btn{
    margin: 0.2rem auto 0;
    width: 1.25rem;
    height: 0.375rem;
    background: #49bc9b;
    font-size: 0.1875rem;
    color: #fff;
    text-align: center;
    line-height: 0.375rem;
    font-family: 'wwf';
    cursor: pointer;
  }

  /**  web  **/

  .phone-user-layer-center{
    padding: 0.5rem 0.5rem;
    background: #fff;
    border-radius: 6px;
  }
  .phone-layer-center-title{
    width: 7.2rem;
    height: auto;
    margin-bottom: 0.7rem;
  }
  .phone-center-title-img{
    width: 0.45rem;
    height: auto;
  }
  .phone-center-title-font{
    font-size: 0.56rem;
    color: #000;
    font-family: 'wwf';
    margin-left: 0.42rem;
  }
  .phone-layer-center-list{
    width: 100%;
    height: 1rem;
    margin-bottom: 0.5rem;
  }
  .phone-center-list-left{
    width: auto;
    height: 100%;
  }
  .phone-list-left-img{
    width: 0.51rem;
    height: 0.51rem;
    margin-right: 0.2rem;
  }
  .phone-list-left-font{
    font-size: 0.32rem;
    color: #000;
    font-family: 'wwf';
    width: 1.6rem;
    margin-right: 0.2rem;
    text-align: justify;
    height: 1rem;
    line-height: 1rem;
  }
  .phone-list-left-font::after{
    content: "";
    display: inline-block;
    width: 100%;
  }
  .phone-center-list-right{
    flex: 2;
    height: 100%;
    border:1px solid #999999;
  }
  .phone-list-right-input{
    padding: 0 0.25rem;
    color: #000;
    font-size: 0.32rem;
    line-height: 1rem;
    width: 100%;
    border:none;
    outline:none;
    background:none;
  }
  .phone-list-right-input:focus{   
    border:none;
  }
  .phone-layer-center-btn{
    margin: 0.4rem auto 0;
    width: 3.2rem;
    height: 0.85rem;
    background: #49bc9b;
    font-size: 0.32rem;
    color: #fff;
    text-align: center;
    line-height: 0.85rem;
    font-family: 'wwf';
  }
</style>
